import React from "react";
import _ from "lodash";

import IColumn from "models/IColumn";
import { PictureAsPdf } from "components/Icons";
import { downloadDocument } from "helpers/download";
import { markAsRead } from "../app/actions";
import { getFormatted } from "helpers/formatting";
import { ROLE_IDS } from "constants/.";

export const columns: IColumn[] = [
  {
    key: "checkbox",
    isSortable: false,
    fixedWidth: 52,
    visible: true,
    notRowClick: true
  },
  {
    key: "pdf",
    isSortable: false,
    render: rowData => (
      <PictureAsPdf
        id={`download-orders-${rowData.DocumentId}.pdf`}
        onClick={e => {
          e.stopPropagation();
          downloadDocument(
            rowData,
            () =>
              !_.get(rowData, "Read", true) && markAsRead([rowData.Id], "Order")
          );
        }}
      />
    ),
    fixedWidth: 52,
    visible: true,
    notRowClick: true
  },
  {
    title: "ORDERS_NUMBER",
    key: "Number",
    fixedWidth: 128,
    visible: true
  },
  {
    title: "VERSION_NR",
    key: "VersionNumber",
    visible: true
  },
  {
    title: "STATUS",
    key: "StateId",
    visible: true
  },
  {
    title: "PURCHASE_TYPE",
    key: "RoleId",
    visible: true
  },
  {
    title: "ORDERS_TYPE",
    key: "TypeId",
    visible: true
  },
  {
    title: "ORDERS_LAST_DATE",
    key: "VersionDate",
    type: "date",
    visible: true
  },
  {
    title: "DELIVERIES_END_DATE",
    key: "DeliveryPeriodEnd",
    type: "date",
    visible: false
  },
  {
    title: "COUNTERPARTY_NAME",
    key: "OtherRelation.Name",
    visible: true
  },
  {
    title: "COUNTERPARTY_NR",
    key: "OtherRelation.Number",
    visible: true
  },
  {
    title: "ORDERS_DATE",
    key: "Date",
    type: "date",
    visible: false
  },
  {
    title: "GROWER_NAME",
    key: "Seller.Name",
    render: rowData =>
      ROLE_IDS[rowData.RoleId] !== "Supplier"
        ? "-"
        : _.get(rowData, "Seller.Name", "-"),
    visible: false
  },
  {
    title: "GROWER_NR",
    key: "Seller.Number",
    render: rowData =>
      ROLE_IDS[rowData.RoleId] !== "Supplier"
        ? "-"
        : _.get(rowData, "Seller.Number", "-"),
    visible: false
  },
  {
    title: "HARVEST_YEAR",
    key: "HarvestYear",
    visible: false
  },
  {
    title: "PREFERRED_GROWER_NAME",
    key: "Supplier.Name",
    visible: false
  },
  {
    title: "PREFERRED_GROWER_NR",
    key: "Supplier.Number",
    visible: false
  },
  {
    title: "ORDERS_AMOUNT",
    key: "TotalAmount",
    render: rowData =>
      rowData.TotalAmount && ROLE_IDS[rowData.RoleId] !== "Supplier"
        ? getFormatted(rowData.TotalAmount, "currency")
        : "-",
    type: "currency",
    visible: false
  },
  {
    title: "PAYMENT_DATE",
    key: "PaymentDate",
    type: "date",
    visible: false
  },
  {
    title: "ORDERS_SCHEME",
    key: "InCoverScheme",
    type: "boolean",
    visible: false
  },
  {
    title: "ORDERS_PAYMENT",
    key: "AdvancePayment",
    type: "boolean",
    visible: false
  },
  {
    title: "ORDERS_FROM_DATE",
    key: "DeliveryPeriodStart",
    type: "date",
    visible: false
  },
  {
    title: "BIO",
    key: "Bio",
    type: "boolean",
    visible: false
  }
];
